import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container _intro sub_page" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }
const _hoisted_4 = { class: "sub_page_con wrap_1120" }
const _hoisted_5 = { class: "bread_crumbs" }
const _hoisted_6 = { class: "faq_title" }
const _hoisted_7 = { class: "sub_page_con_view con_view" }
const _hoisted_8 = { class: "tit_wrap flex_wrap" }
const _hoisted_9 = { class: "con_tit" }
const _hoisted_10 = { class: "content_wrap" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "file_list_wrap _column"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "file_name" }
const _hoisted_15 = {
  key: 0,
  class: "btn_wrap _default right_btn _board_type"
}
const _hoisted_16 = { class: "list_wrap" }
const _hoisted_17 = { class: "list_tit elips_1" }
const _hoisted_18 = {
  key: 0,
  class: "list_date"
}
const _hoisted_19 = {
  key: 1,
  class: "list_date"
}
const _hoisted_20 = { class: "list_tit elips_1" }
const _hoisted_21 = {
  key: 0,
  class: "list_date"
}
const _hoisted_22 = {
  key: 1,
  class: "list_date"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"deco_wrap\" data-v-555ef60b><i class=\"deco_01 _xsmall spin3\" data-v-555ef60b><img src=\"img/b_icon_03.png\" data-v-555ef60b></i><i class=\"deco_02 _small blink_zoom1\" data-v-555ef60b><img src=\"img/b_icon_01.png\" data-v-555ef60b></i><i class=\"deco_03 _xsmall spin_blink2\" data-v-555ef60b><img src=\"img/b_icon_03.png\" data-v-555ef60b></i><i class=\"deco_04 _small blink_blink3\" data-v-555ef60b><img src=\"img/b_icon_01.png\" data-v-555ef60b></i><i class=\"deco_character\" data-v-555ef60b><img src=\"img/intro_icon.png\" data-v-555ef60b></i></div><div class=\"banner_wrap wrap_1120\" data-v-555ef60b><h2 data-v-555ef60b>소개</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab(1))),
              class: _normalizeClass([$setup.state.tab === 1 ? 'active' : ''])
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "반성매매 시민참여 플랫폼", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab(2))),
              class: _normalizeClass([$setup.state.tab === 2 ? 'active' : ''])
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "다시함께상담센터", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab(3))),
              class: _normalizeClass([$setup.state.tab === 3 ? 'active' : ''])
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "자주 묻는 질문", -1)
            ]))], 2)
          ], 2)
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "icon_wrap"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createElementVNode("img", {
                src: "img/home_icon.png",
                alt: "홈"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "자주묻는 질문(FAQ)"
            })
          ], -1)),
          _createVNode(_component_router_link, { to: { path: '/intro', query: { type: 3 } } }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("자주묻는 질문(FAQ)", -1)
            ]))]),
            _: 1
          }),
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "서울시 인터넷시민감시단 참여 신청은 어디서 하나요?"
            })
          ], -1)),
          _createElementVNode("a", _hoisted_6, _toDisplayString($setup.state.data.title), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString($setup.state.data.title), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "content",
              innerHTML: $setup.CommonUtils.decodeContent($setup.state.data.content)
            }, null, 8, _hoisted_11),
            ($setup.state.data.fileList != null && $setup.state.data.fileList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.fileList, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.fileIdx
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => ($setup.downloadFile(item.file, item.fileImgRealName))
                      }, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.fileImgRealName), 1),
                        _cache[15] || (_cache[15] = _createElementVNode("img", {
                          src: "img/download.png",
                          alt: ""
                        }, null, -1))
                      ], 8, _hoisted_13)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          ($setup.state.hasAuth)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "common_btn _gray",
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.confirmRemove && $setup.confirmRemove(...args)))
                }, "삭제"),
                _createElementVNode("button", {
                  class: "common_btn",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.router.push({ name: 'FaqModify', params: { id: $setup.state.idx } })))
                }, "수정"),
                _createElementVNode("button", {
                  class: "common_btn",
                  type: "button",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.router.push('/intro?type=3')))
                }, "목록")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          ($setup.state.data.next)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'FaqView', params: { id: $setup.state.data.next.idx } },
                class: "next_list"
              }, {
                default: _withCtx(() => [
                  _cache[16] || (_cache[16] = _createElementVNode("span", null, "다음글", -1)),
                  _createElementVNode("div", _hoisted_17, _toDisplayString($setup.state.data.next.title), 1),
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.next.createDate), ".", true)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date($setup.state.data.next.createDate), ".", true)), 1))
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          ($setup.state.data.prev)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'FaqView', params: { id: $setup.state.data.prev.idx } },
                class: "prev_list"
              }, {
                default: _withCtx(() => [
                  _cache[17] || (_cache[17] = _createElementVNode("span", null, "이전글", -1)),
                  _createElementVNode("div", _hoisted_20, _toDisplayString($setup.state.data.prev.title), 1),
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.prev.createDate), ".", true)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date($setup.state.data.prev.createDate), ".", true)), 1))
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}